"use client";

import { useQueryClient } from "@tanstack/react-query";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { useSignalREvent } from "@/lib/signalr/useSignalREvent";
import { SIGNALR_EVENTS } from "@/lib/signalr/events";
import type { CcofCardChangedEvent } from "@/lib/signalr/types";
import { useUpdatePatientDetailsCache } from "./useUpdatePatientDetailsCache";
import { patientDetailsQueryKey } from "../queries/usePatientDetails";

export function usePatientDetailsCardChangedEvent(
  patientId: string | null,
): void {
  const queryClient = useQueryClient();
  const { tenantId } = useTenantRouteContext();
  const updatePatientDetailsCache = useUpdatePatientDetailsCache(
    patientId ?? "",
  );

  useSignalREvent<CcofCardChangedEvent>(
    SIGNALR_EVENTS.CCOF_CARD_CHANGED,
    (event) => {
      if (!patientId || !event.patientId || event.patientId !== patientId) {
        return;
      }

      if (event.patient) {
        updatePatientDetailsCache(event.patient);
        return;
      }

      void queryClient.invalidateQueries({
        queryKey: patientDetailsQueryKey(tenantId, patientId),
      });
    },
  );
}
